import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { SpeakersContent } from '@/components/ui/features/hubs-speakers/SpeakersContent/SpeakersContent';
import { SpeakersSearchInput } from '@/components/ui/features/hubs-speakers/SpeakersSearchInput/SpeakersSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { querySelectedSpeakersFilterEvent } from '@/queries/algolia-filter-item';
import { getHubBySlug, getHubsSubtree } from '@/queries/hubs';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Speakers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Fragment>
      <NextSeo title="Hub Speakers" />
      <Hydrate fallback={fallback}>
        <Layout accessFrom={AccessFrom.Hubs}>
          <SpeakersSearchInput />
          <SpeakersContent />
        </Layout>
      </Hydrate>
    </Fragment>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { slug, query, event_id } = urlQueryStringValidate<{
    slug: string;
    query: string;
    event_id: string;
  }>(context.query, {
    slug: StringParam,
    query: StringParam,
    event_id: StringParam,
  });

  const { data } = await store.fetchResource(getHubBySlug(slug));

  await store.fetchResourceRelationship(getHubsSubtree(data.id));

  // ThinProfile infinite query is now handled client-side via tanstack

  if (event_id) {
    await store.fetchResource(
      querySelectedSpeakersFilterEvent({
        event_id,
        query,
        selected_resource: 'event',
        selected_id: event_id,
      })
    );
  }

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Speakers;
